import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as materiasService from '../../services/materias/materiasService';
import {
  classifyMateriasError,
  toCreateMateriaPayload,
  validateMateriaForm
} from '../../services/materias/materiasDto';
import Select from '../common/AppSelect';
import { LookupCarreras } from '../Carreras/LookupCarreras';

import { YES_NO_OPTIONS } from '../../services/selectOptions';

const options = YES_NO_OPTIONS;

const optionsCuatrimestre = [
  { value: '1', label: 'Primer cuatrimestre' },
  { value: '2', label: 'Segundo cuatrimestre' },
  { value: 'A', label: 'Anual' },
];

export class AddMateria extends Component {
  static displayName = AddMateria.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      code: "",
      name: "",
      anioDictado: "",
      dictado: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      tagData: [{id:"",text:""}],
      alumno: { alumnoDni: "", alumnoCodigo: 0, alumnoNombre: "" },
      carrera: { codigo: "", nombre: "" },
      showLookupStudent: false,
      showLookupCarreras: false,
      practica: "",
      value: { value: '', label: '' },
      valueDictado: { value: '', label: '' },
      formato:""
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSelectCarreraItem = this.handleSelectCarreraItem.bind(this);
    this.handleShowCarreraLookup = this.handleShowCarreraLookup.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);
    this.handleAnioChangeInput = this.handleAnioChangeInput.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleFormatoChangeInput = this.handleFormatoChangeInput.bind(this);
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveStudent();
    } else {
      this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });
    }
  }

  async componentDidMount() {
    await constantClass.canAccess('WWMaterias');
  }

  handleSelectCarreraItem = (e) =>
  {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupCarreras: false,
      carrera: {
        codigo: carreraProperties[0],
        nombre: carreraProperties[1]
      }
    });
  }

  handleSelect = e => {
    this.setState({ practica: e.value, value: e });
  }

  handleHideLookup = () =>
  {
    this.setState({showLookupCarreras:false});
  }

  handleShowCarreraLookup = () =>
  {
    this.setState({showLookupCarreras:true});
  }

  handleNameChangeInput = e => {
    this.setState({ name: e.target.value });
  }

  handleFormatoChangeInput = e => {
    this.setState({ formato: e.target.value });
  }

  handleAnioChangeInput = e => {
    this.setState({ anioDictado: e.target.value });
  }

  handleDictadoChangeInput = e => {
    this.setState({ dictado: e.value, valueDictado:e });
  }

  handleCodeChange = e => {
    this.setState({ code: e.target.value });
  }

  handleDelete = (i) => {
    this.setState({tagData:this.state.tagData.filter(tag =>tag.id !== i)});
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-mxc" />;
    }

    const { loading } = this.state;
    const carreraDisplay = this.state.carrera.codigo.trim() + ' - ' + this.state.carrera.nombre.trim();

    return (
      <div className="md-page md-add-materia">
        <Link className="md-page__back-link" to="/md-mxc">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Materia</h1>
        </div>
        <p className="md-page__subtitle">
          Complete los datos de la materia y seleccione la carrera correspondiente.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-codigo">
              Código Materia
            </label>
            <input
              id="materia-codigo"
              className="md-page__field-input"
              name="code"
              placeholder="Ingrese Código"
              onChange={this.handleCodeChange}
              disabled={loading}
              value={this.state.code}
              required
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-nombre">
              Nombre Materia
            </label>
            <input
              id="materia-nombre"
              className="md-page__field-input"
              name="name"
              placeholder="Ingrese Nombre"
              onChange={this.handleNameChangeInput}
              disabled={loading}
              value={this.state.name}
              required
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-anio">
              Año Dictado
            </label>
            <input
              id="materia-anio"
              className="md-page__field-input"
              name="anioDictado"
              placeholder="Ingrese Año"
              onChange={this.handleAnioChangeInput}
              disabled={loading}
              value={this.state.anioDictado}
              required
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="materia-formato">
              Formato de la Materia
            </label>
            <input
              id="materia-formato"
              className="md-page__field-input"
              name="formato"
              placeholder="Ingrese Formato"
              onChange={this.handleFormatoChangeInput}
              disabled={loading}
              value={this.state.formato}
              required
            />
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de Dictado</span>
            <Select
              className="md-page__field-select"
              value={this.state.valueDictado}
              options={optionsCuatrimestre}
              onChange={this.handleDictadoChangeInput}
              disabled={loading}
            />
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Carrera</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar carrera
                </button>
              ) : null}
              <div className="md-page__field-readonly">{carreraDisplay.trim() !== '-' ? carreraDisplay : ''}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Materia Práctica</span>
            <Select
              className="md-page__field-select"
              value={this.state.value}
              options={options}
              onChange={this.handleSelect}
              disabled={loading}
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupCarreras ? (
          <LookupCarreras selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return validateMateriaForm({
      code: this.state.code,
      name: this.state.name,
      anioDictado: this.state.anioDictado,
      dictado: this.state.dictado,
      practica: this.state.practica,
      carreraPresent: this.state.carrera.nombre.length >= 1,
      formato: this.state.formato
    }, { requireFormato: true });
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await materiasService.saveMateria(
        toCreateMateriaPayload({
          code: this.state.code,
          name: this.state.name,
          dictado: this.state.dictado,
          anioDictado: this.state.anioDictado,
          practica: this.state.practica,
          carreraCod: this.state.carrera.codigo,
          formato: this.state.formato
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyMateriasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
